import React, { Component } from 'react'
import { safeParse } from '../utils';
const Parser = safeParse;

import TextPage from '../block/TextPage'
import Oblast from '../block/Oblast'
import Faq from '../block/Faq'

class App extends Component {

  render() {

    const data = this.props?.data

    return (
      <>
        <TextPage data={data} />
        <div className={`overflow-x-hidden`}>
          <div className='container'>

            <div className='grid mt-[20px] gap-[10px] grid-cols-1 md:grid-cols-3 xl:grid-cols-4'>
              {data?.submenu.map((elm, k) => (
                <a href={elm?.url}
                  key={k}
                  style={{
                    backgroundImage: `url("${elm.image}")`,
                    backgroundSize: 'cover'
                  }}
                  className="
                    min-h-[166px] xl:min-h-[180px] rounded-[15px] p-[20px]
                  "
                >
                  <div className='w-full flex justify-end'>
                    {k == 1 ? (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22 15C22 18.87 18.87 22 15 22L16.05 20.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2 9C2 5.13 5.13 2 9 2L7.95 3.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.7031 4.4502L17.6831 6.75018L21.6231 4.46021" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M17.6836 10.8203V6.74023" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16.7416 2.21L14.3416 3.53996C13.8016 3.83996 13.3516 4.59995 13.3516 5.21995V7.75999C13.3516 8.37999 13.7916 9.13998 14.3416 9.43998L16.7416 10.77C17.2516 11.06 18.0916 11.06 18.6116 10.77L21.0116 9.43998C21.5516 9.13998 22.0016 8.37999 22.0016 7.75999V5.21995C22.0016 4.59995 21.5616 3.83996 21.0116 3.53996L18.6116 2.21C18.1016 1.93 17.2616 1.93 16.7416 2.21Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2.35156 15.4502L6.32156 17.7502L10.2716 15.4602" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6.32031 21.8203V17.7402" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5.39 13.21L2.99001 14.54C2.45001 14.84 2 15.5999 2 16.2199V18.76C2 19.38 2.44001 20.14 2.99001 20.44L5.39 21.77C5.9 22.06 6.73999 22.06 7.25999 21.77L9.66 20.44C10.2 20.14 10.65 19.38 10.65 18.76V16.2199C10.65 15.5999 10.21 14.84 9.66 14.54L7.25999 13.21C6.73999 12.93 5.9 12.93 5.39 13.21Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    ) : (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 2V12C15 13.1 14.1 14 13 14H2V6C2 3.79 3.79 2 6 2H15Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M22 14V17C22 18.66 20.66 20 19 20H18C18 18.9 17.1 18 16 18C14.9 18 14 18.9 14 20H10C10 18.9 9.1 18 8 18C6.9 18 6 18.9 6 20H5C3.34 20 2 18.66 2 17V14H13C14.1 14 15 13.1 15 12V5H16.84C17.56 5 18.22 5.39001 18.58 6.01001L20.29 9H19C18.45 9 18 9.45 18 10V13C18 13.55 18.45 14 19 14H22Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8 22C9.10457 22 10 21.1046 10 20C10 18.8954 9.10457 18 8 18C6.89543 18 6 18.8954 6 20C6 21.1046 6.89543 22 8 22Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16 22C17.1046 22 18 21.1046 18 20C18 18.8954 17.1046 18 16 18C14.8954 18 14 18.8954 14 20C14 21.1046 14.8954 22 16 22Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M22 12V14H19C18.45 14 18 13.55 18 13V10C18 9.45 18.45 9 19 9H20.29L22 12Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    )}
                  </div>
                  <div className='mt-[85px] text-[16px] xl:text-[18px] text-white'>{Parser(elm.pagetitle)}</div>
                </a>
              ))}
            </div>
          </div>
        </div>
        <Oblast data={data} />
        <Faq data={data} />
      </>
    )
  }
}

export default App